import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { NOTIFICATION_TYPE } from 'enum/messages';

import BasicMobileNotification from './BasicMobileNotification';
import BoostNotification from './BoostNotification';
import CampaignNotification from './CampaignNotification';
import GameMobileNotitification from './GameMobileNotitification';
import GiftMobileNotification from './GiftMobileNotification';
import LiveTouchMobileNotification from './LiveTouchMobileNotification';
import TippingMobileNotification from './TippingMobileNotification';
import UnsupportedNotification from './UnsupportedNotification';
import VideoMobileNotification from './VideoMobileNotification';
import EventNotificaiton from './EventNotification';
import styles from './ChatNotificationsTypes.css';


class NotificationChatComponent extends PureComponent {
  static propTypes = {
    message: PropTypes.object.isRequired,
    roomName: PropTypes.string.isRequired,
    showBuyTokensModal: PropTypes.func.isRequired,
    chatSettings: PropTypes.object,
    embedProfileV2: PropTypes.bool,
    handleTabsChange: PropTypes.func,
    isBroadcasterChat: PropTypes.bool,
    isDesktop: PropTypes.bool,
    isSfw: PropTypes.bool,
    setShowRegistrationModal: PropTypes.func,
    toggleGameDrawer: PropTypes.func,
  };

  static defaultProps = {
    chatSettings: undefined,
    embedProfileV2: undefined,
    handleTabsChange: undefined,
    isBroadcasterChat: false,
    isDesktop: undefined,
    isSfw: undefined,
    setShowRegistrationModal: () => undefined,
    toggleGameDrawer: undefined,
  };

  getNotificationComponentByType(notificationType) {
    switch (notificationType) {
      case NOTIFICATION_TYPE.SEND_TIP:
        return TippingMobileNotification;

      case NOTIFICATION_TYPE.GIFT:
        return GiftMobileNotification;

      case NOTIFICATION_TYPE.GOLD_ENTERED_ROOM:
      case NOTIFICATION_TYPE.FAN_ENTERED_ROOM:
      case NOTIFICATION_TYPE.JOIN_FANCLUB:
      case NOTIFICATION_TYPE.ROOM_MODERATOR_PRIVILEGES:
        return BasicMobileNotification;

      case NOTIFICATION_TYPE.LIVE_TOUCH:
        return LiveTouchMobileNotification;

      case NOTIFICATION_TYPE.GAME:
        return GameMobileNotitification;

      case NOTIFICATION_TYPE.MARKETPLACE_PURCHASE:
      case NOTIFICATION_TYPE.MARKETPLACE_BULK_PURCHASE:
        return VideoMobileNotification;

      case NOTIFICATION_TYPE.BOOST_STARTED:
      case NOTIFICATION_TYPE.BOOST_ENDED:
        return BoostNotification;

      case NOTIFICATION_TYPE.CAMPAIGN_CTA:
        return CampaignNotification;

      case NOTIFICATION_TYPE.EVENT_NOTIFICATION:
        return EventNotificaiton;

      default:
        return UnsupportedNotification;
    }
  }

  render() {
    const {
      chatSettings,
      embedProfileV2,
      handleTabsChange,
      isBroadcasterChat,
      isDesktop,
      isSfw,
      message,
      roomName,
      showBuyTokensModal,
      setShowRegistrationModal,
      toggleGameDrawer,
    } = this.props;
    const { messageKey, type } = message;

    const Comp = this.getNotificationComponentByType(type);

    const notificationClasses = classNames({
      [styles.none]: isSfw && type === NOTIFICATION_TYPE.MARKETPLACE_PURCHASE,
      [styles.padding]: isBroadcasterChat,
    });

    return (
      <div className={notificationClasses}>
        <Comp
          key={messageKey}
          chatSettings={chatSettings}
          embedProfileV2={embedProfileV2}
          handleTabsChange={handleTabsChange}
          isBroadcasterChat={isBroadcasterChat}
          isDesktop={isDesktop}
          message={message}
          roomName={roomName}
          setShowRegistrationModal={setShowRegistrationModal}
          showBuyTokensModal={showBuyTokensModal}
          toggleGameDrawer={toggleGameDrawer}
          type={type}
        />
      </div>
    );
  }
}

export default NotificationChatComponent;
